import React from "react";
import NoDataFoundImage from "../../Assets/images/Nodata.svg";
import "./NoDataFound.css";

const NoDataFound = () => {
  return (
    <div className="no-data-container">
      <img src={NoDataFoundImage} alt="img" />
      <p>No Data Found</p>
    </div>
  );
};

export default NoDataFound;
